interface Props {
    
}

export const Divider = (props: Props) => {
    return (
        <div style={{width: '100%', height: '1px', background: '#aaa', marginBottom: "1rem"}} />
    )
}
